// api/axios.js
import axios from 'axios';
import store from '@/store';
import router from '@/router';

const instance = axios.create({
  baseURL: import.meta.env.VITE_APP_BASE_URL || 'http://localhost:8000',
  //baseURL: 'https://app.lesplaisirsfruites.com',
});

let isRefreshing = false;
let failedQueue = [];

const publicRoutes = [
  '/authV2/login/',
  '/authV2/register/',
  '/authV2/google/register/',
  '/authV2/google/login/',
  '/authV2/microsoft/register/',
  '/authV2/microsoft/login/',
  '/authV2/token/refresh/',
  '/api/direct-debit/complete',
  '/direct-debit/success',
  '/direct-debit/error',
];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  
  failedQueue = [];
};

const isPublicRoute = (url) => {
  return publicRoutes.some(route => url.includes(route));
};

// Ajout de l'intercepteur de requête
instance.interceptors.request.use(
  (config) => {
    console.log("Request URL:", config.url);
    console.log("Full URL:", config.baseURL + config.url);
    // Ne pas ajouter le header Authorization pour les routes publiques
    if (isPublicRoute(config.url)) {
      // Supprime explicitement le header Authorization s'il existe
      delete config.headers.Authorization;
      return config;
    }
    
    // Pour les routes protégées, ajouter le token
    const token = store.state.accessToken;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    // Si c'est une route publique, on ne tente pas de rafraîchir le token
    if (isPublicRoute(originalRequest.url)) {
      return Promise.reject(error);
    }
    
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({resolve, reject});
        }).then(token => {
          originalRequest.headers['Authorization'] = 'Bearer ' + token;
          return instance(originalRequest);
        }).catch(err => {
          return Promise.reject(err);
        });
      }
      
      originalRequest._retry = true;
      isRefreshing = true;
      
      const refreshToken = store.state.refreshToken;
      
      if (!refreshToken) {
        isRefreshing = false;
        // On ne déconnecte plus l'utilisateur ici
        // store.dispatch('logout');
        // router.push('/auth/login');
        return Promise.reject(error);
      }
      
      try {
        const response = await instance.post('/authV2/token/refresh/', {
          refresh: refreshToken,
        });
        
        const { access } = response.data;
        store.dispatch('login', { 
          access, 
          refresh: refreshToken, 
          role: store.getters.getRole 
        });
        
        processQueue(null, access);
        isRefreshing = false;
        
        // Mettre à jour la requête originale avec le nouveau token
        originalRequest.headers['Authorization'] = 'Bearer ' + access;
        return instance(originalRequest);
      } catch (refreshError) {
        processQueue(refreshError, null);
        isRefreshing = false;
        // On ne déconnecte plus l'utilisateur en cas d'échec
        // store.dispatch('logout');
        // router.push('/auth/login');
        return Promise.reject(refreshError);
      }
    }
    
    return Promise.reject(error);
  }
);

export default instance;